import { useState, useRef, useEffect, useCallback } from 'react';
import EmojiPicker from 'modules/Tickets/components/EmojiPicker/EmojiPicker';
import './FormattingToolbar.scss';

type Props = {
    onInsert: (text: string) => void;
    onWrap: (prefix: string, suffix: string) => void;
};

const FormattingToolbar = ({ onInsert, onWrap }: Props) => {
    const [showEmoji, setShowEmoji] = useState(false);
    const emojiRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                emojiRef.current &&
                !emojiRef.current.contains(event.target as Node)
            ) {
                setShowEmoji(false);
            }
        };
        if (showEmoji) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showEmoji]);

    const handleFormat = useCallback(
        (e: React.MouseEvent, prefix: string, suffix: string) => {
            e.preventDefault();
            onWrap(prefix, suffix);
        },
        [onWrap]
    );

    return (
        <div className="formatting-toolbar">
            <button
                type="button"
                className="formatting-toolbar__btn"
                onMouseDown={(e) => handleFormat(e, '*', '*')}
                title="Negrito"
            >
                <strong>B</strong>
            </button>
            <button
                type="button"
                className="formatting-toolbar__btn"
                onMouseDown={(e) => handleFormat(e, '_', '_')}
                title="Itálico"
            >
                <em>I</em>
            </button>
            <button
                type="button"
                className="formatting-toolbar__btn"
                onMouseDown={(e) => handleFormat(e, '~', '~')}
                title="Tachado"
            >
                <s>S</s>
            </button>
            <button
                type="button"
                className="formatting-toolbar__btn formatting-toolbar__btn--mono"
                onMouseDown={(e) => handleFormat(e, '```', '```')}
                title="Monoespaçado"
            >
                {'</>'}
            </button>
            <div className="formatting-toolbar__emoji-wrapper" ref={emojiRef}>
                <button
                    type="button"
                    className="formatting-toolbar__btn"
                    onClick={() => setShowEmoji(!showEmoji)}
                    title="Emoji"
                >
                    😀
                </button>
                {showEmoji && (
                    <div className="formatting-toolbar__emoji-popover">
                        <EmojiPicker
                            onEmojiSelect={(emoji) => {
                                onInsert(emoji);
                                setShowEmoji(false);
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default FormattingToolbar;
